import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AudioRecorderChat } from '../audio-recorder';
import { Asr, AsrChat } from '../asr';
import { Translation, TranslationChat } from '../translation';
import ChatReply from '../chat-reply/ChatReply';

const CardChat = () => {
    return (
        <Container style={{"background": "#f1f1f0"}}>
            <Row>
                <Col>
                    <div className="card-default">
                        <div>
                            <AudioRecorderChat />
                            <AsrChat />
                            <ChatReply />            
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>

    );
}

export default CardChat;